// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/element-variables.scss';
import store from './store'

import App from './App.vue';
import router from './router'
import VueAnimateNumber from 'vue-animate-number'
import './assets/index.css'
import "babel-polyfill"
Vue.use(VueAnimateNumber)

Vue.use(ElementUI);

import axios from 'axios'
Vue.prototype.$http = axios;

Vue.config.productionTip = false
axios.defaults.baseURL = 'http://218.244.147.161/';
// axios.defaults.baseURL = 'http://cnjishi.cn/';

// 刷新存储
// window.addEventListener("beforeunload",()=>{
//   debu
//   localStorage.setItem("store",JSON.stringify(this.$store.state))
// })


// 遍历路由name 设置页面标题
router.beforeEach((to, from, next) => {
  if (to.query.title) {
    document.title = to.query.title

  } else if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  render: h => h(App),
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js